import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import authApi from '../../api/authApi';
import './Register.css';
import { useDispatch, useSelector } from 'react-redux';
import { setEmailRegister } from './registerSlice';
import { selectUserEmail, setIsBindPay, setUserEmail, setUserId } from '../Login/loginSlice';

const LoginCode = () => {
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [testPassword, setTestPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [step, setStep] = useState('');  // email --prod
    const [isCooldown, setIsCooldown] = useState(false);
    const [cooldownTime, setCooldownTime] = useState(60);

    const [agreement1, setAgreement1] = useState(false);
    const [agreement2, setAgreement2] = useState(false);

    const [referralId, setReferralId] = useState(null);
    const [searchParams] = useSearchParams();

    const [source, setSource] = useState(null);

    const userEmail = useSelector(selectUserEmail)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleEmailSubmit = async () => {
        // console.log('handleEmailSubmit')
        // navigate('/payment')
        try {
            const response = await authApi.register(email, referralId, true, source);
            // console.log('handleEmailSubmit response', response.data)
            if (response.data.status === 'success') {
                setStep('code');
                setIsCooldown(true)
                setCooldownTime(90)

            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время регистрации:', error);
            alert('Произошла ошибка при отправке email.');
        }
    };

    useEffect(() => {
        if (!isCooldown) return;

        const timer = setInterval(() => {
            setCooldownTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setIsCooldown(false);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isCooldown]);

    const handleCodeSubmit = async () => {
        try {
            const response = await authApi.verifyCode(email, code);
            //console.log('response', response.data)
            if (response.data.status === 'success') {
                const balance = response.data.balance
                const userId = response.data.userId
                const isBindPay = !!balance || balance === 0;
                dispatch(setUserId(userId))
                dispatch(setUserEmail(email))
                // dispatch(setIsBindPay(isBindPay))


                const expiresAt = Date.now() + 21 * 24 * 60 * 60 * 1000; // 10 минут
                localStorage.setItem('authData', JSON.stringify({
                    userId,
                    email: email,
                    isBindPay,
                    expiresAt
                }));
                navigate('/chat');
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время проверки кода:', error);
            alert('Произошла ошибка при проверке кода.');
        }
    };

    const handlePasswordSubmit = async () => {
        try {
            const response = await authApi.verifyPassword(email, password, referralId);
            if (response.data.status === 'success') {
                navigate('/login')
                // dispatch(setUserEmail(email))
                // alert(`userId ${response.data.user_id}`);
                // dispatch(setUserId(response.data.user_id))
                // navigate('/payment')
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время проверки кода:', error);
            alert('Произошла ошибка при проверке пароля.');
        }
    };

    const handleRefreshCode = async () => {
        if (isCooldown) return; // Блокируем отправку, если таймер активен

        try {
            const response = await authApi.register(email, referralId, true);
            if (response.data.status === 'success') {
                alert('Код повторно отправлен. Проверьте почту.');
                setIsCooldown(true);
                setCooldownTime(60); // Перезапускаем таймер
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка при повторной отправке кода:', error);
            alert('Произошла ошибка при повторной отправке кода.');
        }
    };

    const isPasswordValid = (password) => {
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasDigit = /\d/.test(password);
        const hasSpecialChar = /[^a-zA-Z\d]/.test(password);
        const compare = password === confirmPassword && confirmPassword !== ''
        return hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar && compare;
    };


    const handleTestPasswordSubmit = async () => {
        try {
            const response = await authApi.verifyTestPassword(testPassword);
            // //console.log('response.data', response.data)
            if (response.data.status === 'success') {
                setStep('email')
            } else {
                alert(response.data.error);
            }
        } catch (error) {
            console.error('Ошибка во время проверки кода:', error);
            alert('Произошла ошибка при проверке кода.');
        }
    };


    // useEffect(() => {
    //     const ref = searchParams.get('ref');
    //     //console.log('ref', ref)
    //     if (ref) {
    //         setReferralId(ref);
    //     }
    // }, [searchParams]);


    useEffect(() => {
        const ref = searchParams.get('ref');
        const sourceParams = searchParams.get('source');
        //console.log('sourceParams', sourceParams)
        if (ref) {

            setReferralId(ref);
            return
        }
        if (sourceParams) {
            setSource(sourceParams);
            return
        }
        // Проверяем, есть ли активная авторизация
        const authData = localStorage.getItem('authData');
        // console.log('authData', authData)
        if (authData) {
            const { expiresAt, userId, email, isBindPay } = JSON.parse(authData);
            if (Date.now() < expiresAt) {
                // Восстанавливаем состояние пользователя
                dispatch(setUserId(userId));
                dispatch(setUserEmail(email));
                // dispatch(setIsBindPay(isBindPay));
                navigate('/chat', { replace: true });
            } else {
                localStorage.removeItem('authData');
            }
        }
    }, [dispatch, navigate, searchParams]);




    return (
        <div className="register-container">
            <div className="register-form">
                <h2>Авторизация</h2>

                {step === 'email' ? (
                    <>
                        <div className="mb-3">
                            <label htmlFor="email"><strong>Email</strong></label>
                            <input
                                type="email"
                                placeholder="Введите Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className='reg_input'
                            />
                        </div>


                        <div className="agreement-container" >
                            <div className="styled-checkbox">
                                <div className='cntr_checkbox' style={{ width: '35px' }}>
                                    <input
                                        type="checkbox"
                                        id="agreement1"
                                        checked={agreement1}
                                        onChange={(e) => setAgreement1(e.target.checked)}
                                    />
                                </div>

                                <label className='mini_text' htmlFor="agreement1">
                                    {/* Даю <a href="https://bottax.tech/pii_agree/">Согласие</a> на обработку персональных данных */}
                                    Проходя авторизацию, вы даете <a href="https://bottax.tech/pii_agree/">Согласие</a> на обработку персональных данных и принимаете <a href="https://bottax.tech/agreement/">Пользовательское соглашение</a>.
                                    <br />
                                </label>
                            </div>
                        </div>
                        <div className="agreement-container" style={{ display: 'none' }}>
                            <div className="styled-checkbox">
                                <div className='cntr_checkbox' style={{ width: '35px' }}>
                                    <input
                                        type="checkbox"
                                        id="agreement2"
                                        checked={agreement2}
                                        onChange={(e) => setAgreement2(e.target.checked)}
                                    />
                                </div>
                                {/* <label className='mini_text' htmlFor="agreement2">Принимаю <a href="https://bottax.tech/policy/">Политику обработки</a> персональных данных </label> */}
                                <label className='mini_text' htmlFor="agreement2">Принимаю <a href="https://bottax.tech/agreement/">Пользовательское соглашение</a></label>
                            </div>
                        </div>

                        <button
                            className={`register_button ${!agreement1 || !agreement2 ? '' : ''}`}
                            onClick={handleEmailSubmit}
                            // disabled={!agreement1 || !agreement2}
                            disabled={!email.trim() || !agreement1}
                        >
                            Вход
                        </button>

                    </>
                ) : step === 'code' ? (
                    <>
                        <div className="mb-3">
                            <label style={{ textAlign: 'center' }} htmlFor="code">
                                <strong>Вам на почту отправлен код, введите его в поле</strong>
                            </label>
                            <input
                                type="text"
                                placeholder="Введите код"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button
                            className="register_button"
                            onClick={handleCodeSubmit}
                        >
                            Ок
                        </button>
                        <p className="cooldown-message">
                            {isCooldown
                                ? `Код был отправлен. Не забудьте проверить папку спам. Вы можете повторно запросить через ${cooldownTime} секунд.`
                                : 'Код не пришел?'}
                        </p>
                        {!isCooldown &&
                            <button
                                className="forgot_button"
                                onClick={handleRefreshCode}
                                disabled={isCooldown}
                            >
                                Повторно отправить код
                            </button>
                        }
                    </>
                ) : step === 'password' ? (
                    <>
                        <div className="mb-1">
                            <label htmlFor="password"><strong>Пароль</strong></label>
                            <input
                                type="password"
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="confirmPassword"><strong>Подтвердите пароль</strong></label>
                            <input
                                type="password"
                                id="confirmPassword"
                                placeholder="Повторите пароль"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <ul className="password-requirements">
                            <li className={password.match(/[A-Z]/) ? "valid" : "invalid"}>
                                Большая буква (A-Z)
                            </li>
                            <li className={password.match(/[a-z]/) ? "valid" : "invalid"}>
                                Маленькая буква (a-z)
                            </li>
                            <li className={password.match(/\d/) ? "valid" : "invalid"}>
                                Хотя бы одна цифра (0-9)
                            </li>
                            <li className={password.match(/[^a-zA-Z\d]/) ? "valid" : "invalid"}>
                                Специальный символ (!@#$%^&*)
                            </li>
                            <li className={password === confirmPassword && confirmPassword !== '' ? "valid" : "invalid"}>
                                Пароли совпадают
                            </li>
                        </ul>
                        <button
                            className="register_button"
                            onClick={handlePasswordSubmit}
                            disabled={!isPasswordValid(password)}
                        > Установить пароль
                        </button>
                    </>
                ) : step === '' ? (
                    <>
                        <div className="mb-3">
                            <label style={{ textAlign: 'center' }} htmlFor="code">
                                <strong>Введите пароль тестировщика</strong>
                            </label>
                            <input
                                type="text"
                                placeholder="Пароль"
                                value={testPassword}
                                onChange={(e) => setTestPassword(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button
                            className="register_button"
                            onClick={handleTestPasswordSubmit}
                        >
                            Ок
                        </button>
                    </>
                ) : null
                }
            </div>
        </div>
    );
};

export default LoginCode
